const toggleClass = (element, className) => {
  const currentClass = element.className
  let newClass
  if (currentClass.split(' ').indexOf(className) > -1) {
    // has class
    newClass = currentClass.replace(new RegExp(`\\b${className}\\b`, 'g'), '')
  } else {
    newClass = `${currentClass} ${className}`
  }
  return newClass.trim()
}

export default toggleClass



// WEBPACK FOOTER //
// ./src/helpers/toggleControlButtonClass.js